import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { startPurchaseEvents, stopPurchaseEvents } from '../utils/purchaseEventsHub';
import {
  getSelectedCompanyId,
  subscribeSelectedCompany,
} from '../utils/selectedCompany';
import {
  getSelectedBranchId,
  subscribeSelectedBranch,
} from '../utils/selectedBranch';

const normalizeBranchId = (value) => {
  const normalized = String(value || '').trim();
  return /^\d+$/.test(normalized) && Number(normalized) > 0 ? normalized : '';
};

export const resolvePurchaseEventsBranchId = ({
  pathname = '',
  search = '',
  selectedBranchId = '',
} = {}) => {
  if (pathname.startsWith('/client-portal')) return '';
  const routeBranchId = pathname.match(/\/branches\/(\d+)/)?.[1] || '';
  if (routeBranchId) return routeBranchId;
  const settingsSection = pathname.match(/^\/settings\/[^/]+\/([^/]+)\/?$/)?.[1] || '';
  const usesReferenceBranch = [
    'catalog-price-list',
    'client-pricing-categories',
  ].includes(settingsSection);
  if (usesReferenceBranch) {
    const settingsBranchId = normalizeBranchId(
      new URLSearchParams(search || '').get('branchId')
    );
    if (settingsBranchId) return settingsBranchId;
  }
  return normalizeBranchId(selectedBranchId);
};

const PurchaseEventsProvider = () => {
  const location = useLocation();
  const [selectedCompanyId, setSelectedCompanyId] = useState(getSelectedCompanyId);
  const [selectedBranchId, setSelectedBranchId] = useState(getSelectedBranchId);
  const branchId = resolvePurchaseEventsBranchId({
    pathname: location.pathname,
    search: location.search,
    selectedBranchId,
  });

  useEffect(() => subscribeSelectedCompany(setSelectedCompanyId), []);
  useEffect(() => subscribeSelectedBranch(setSelectedBranchId), []);

  useEffect(() => {
    startPurchaseEvents({ branchId, companyId: selectedCompanyId });
    return () => {
      stopPurchaseEvents();
    };
  }, [branchId, selectedCompanyId]);

  return null;
};

export default PurchaseEventsProvider;
